import { getSupportedLocaleMetadata } from './get-supported-locale-metadata.helper';
export function formatLanguageLabel(locale) {
    const { name } = getSupportedLocaleMetadata(locale);
    return `${name.english} - ${name.native} (${locale})`;
}
